import AdminVersionDiffPage from './AdminVersionDiffPage'
export default AdminVersionDiffPage
